
export const Border = ( { height, width }) => (
  <>
    <line className="axis-line" 
      x2={width}
      y1={height}
      y2={height}
      style={{stroke: "c0c0bb", strokeWidth: 2}}
    />
    <line 
      className="axis-line" 
      y2={height}
      style={{stroke: "c0c0bb", strokeWidth: 2}}
    />
  </>
);
